import { render, staticRenderFns } from "./CreateDraw.vue?vue&type=template&id=96c78c68"
import script from "./CreateDraw.vue?vue&type=script&lang=js"
export * from "./CreateDraw.vue?vue&type=script&lang=js"
import style0 from "./CreateDraw.vue?vue&type=style&index=0&id=96c78c68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports